import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { OneDeskLoginApi } from "@repo/api-client";
import type { OneDeskLoginRequest } from "@repo/types";
import { getUserIP } from "@repo/utils";

export const useOneDeskLogin = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState<OneDeskLoginRequest>({
    Username: "",
    Password: "",
    IP: "127.0.0.1",
  });

  useEffect(() => {
    const initIP = async () => {
      const ip = await getUserIP();
      setFormData((prev: any) => ({ ...prev, IP: ip }));
    };
    initIP();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.Username || !formData.Password) {
      toast.error("Please fill in all fields");
      return;
    }

    setIsLoading(true);
    try {
      const response = await OneDeskLoginApi(formData);

      if (response.Success && response.Data && response.Data.length > 0) {
        const token = response.Data[0].Token;
        localStorage.setItem("OneDeskToken", token);
        toast.success(response.Message || "Login Successful!");

        setTimeout(() => {
          navigate("/dashboard");
        }, 1000);
      } else {
        console.warn("Login Failed (Success=false or no data):", response);
        toast.error(
          response.Message || "Invalid credentials. Please try again.",
        );
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Something went wrong. Please check your connection.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    formData,
    isLoading,
    showPassword,
    setShowPassword,
    handleChange,
    handleLogin,
  };
};
